<template>
  <div class="image-dimensions-row" :style="{ gridTemplateColumns: `repeat(${normalizedItems.length}, minmax(0, 1fr))` }">
    <div v-for="(item, index) in normalizedItems" :key="`${item.url || 'empty'}-${index}`">
      <i class="el-icon-full-screen"></i>
      <span>{{ item.label || '图片尺寸' }}</span>
      <strong>{{ dimensions[index] || '无' }}</strong>
    </div>
  </div>
</template>

<script>
import { loadImagePixelDimensions } from '@/utils/imagePixelDimensions'

export default {
  name: 'ImageDimensionsRow',
  props: {
    items: { type: Array, default: () => [] }
  },
  data() {
    return { dimensions: [] }
  },
  computed: {
    normalizedItems() {
      return this.items && this.items.length ? this.items : [{ label: '图片尺寸', url: '' }]
    }
  },
  watch: {
    normalizedItems: {
      immediate: true,
      deep: true,
      handler(items) {
        this.dimensions = items.map(item => (
          Number(item.width) > 0 && Number(item.height) > 0
            ? `${Number(item.width)} × ${Number(item.height)}`
            : ''
        ))
        items.forEach((item, index) => {
          if (!item.url || this.dimensions[index] || item.probe !== true) return
          loadImagePixelDimensions(item.url).then(value => {
            if (value) this.$set(this.dimensions, index, value)
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.image-dimensions-row { width:100%; display:grid; gap:1px; border-top:1px solid #e2e7e3; border-bottom:1px solid #e7ebe8; background:#dfe5e1; }
.image-dimensions-row > div { min-width:0; min-height:38px; display:flex; align-items:center; gap:7px; padding:0 11px; background:#f8faf9; color:#7b8780; font-size:9px; }
.image-dimensions-row i { flex:0 0 auto; color:#5076b9; font-size:12px; }
.image-dimensions-row span { min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.image-dimensions-row strong { min-width:0; margin-left:auto; overflow:hidden; color:#34443b; font-size:10px; font-variant-numeric:tabular-nums; text-overflow:ellipsis; white-space:nowrap; }
</style>
